
import { defineComponent } from "vue";
import api, { TemplateList, Template, SheqsyMessageList, RequestPaging, PageBounding, RequestSort, RequestParams }  from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: TemplateList;
  requestFilter: Template;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  sheqsyMessageList: SheqsyMessageList;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "ReceiverTemplate",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const template_list = { } as TemplateList;
    const template_struct = { } as Template;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {
      'Enabled': [
        { 'label': 'Yes', 'value': true },
        { 'label': 'No', 'value': false }
      ]
    };
    const sheqsyMessageList = { } as SheqsyMessageList;

    return {
      msg: "Receiver Templates",
      backendResponse: template_list,
      requestFilter: template_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      sheqsyMessageList: sheqsyMessageList,
      pageBounds: [],
      errors: [],
      filterOptions: filter_options,
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    createTemplate() {
      api
        .createReceiverTemplate('sheqsy:sims')
        .then((response) => {
          this.$router.push('/receiver/template/'+response.data.id)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as Template;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse = { } as TemplateList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getReceiverTemplateList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });

      const params = { 
        Paging: { Limit: 50 },
        Sorting: { Pattern: 'Message' }
      } as RequestParams
      api.getSheqsyMessageList(params)
        .then((response) => {
          this.sheqsyMessageList = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });

    },
  },
});
